import { usePost } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { DateRangeReportFilter, IdReportFilter, RecencyReportFilter, ReportTemplateGetPreviewWithFilters, ReportTemplatePreviewResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<ReportTemplatePreviewResponse, ReportTemplatePreviewResponse>) => {
    return response?.data;
}
const getError = (response?: SWRResponse<ReportTemplatePreviewResponse, ReportTemplatePreviewResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => ({});

const useReportTemplatePreviewByIdFilters = (
    templateId?: number, 
    idFilters?: IdReportFilter[], 
    dateRangeFilters?: DateRangeReportFilter[], 
    recencyFilters?: RecencyReportFilter[], 
    configuration?: SWRConfiguration<ReportTemplatePreviewResponse, ReportTemplatePreviewResponse>
) => {
    const request = useMemo(() => {
        if(!templateId) return undefined;
        return () => {
            return new ReportTemplateGetPreviewWithFilters({
                templateId: templateId,
                idReportFilters: idFilters,
                dateRangeReportFilters: dateRangeFilters,
                recencyReportFilters: recencyFilters
            });
        };        
    }, [templateId, idFilters, dateRangeFilters, recencyFilters])
    
    return usePost(request, { getData, getError }, configuration);
}

export default useReportTemplatePreviewByIdFilters;